import { useAccountRequestListPageProps } from "./fetch";
import { AccountRequestListPage as UI } from "./ui";

export const AccountRequestListPage = () => {
  const props = useAccountRequestListPageProps();
  return <UI {...props} />;
};
